import React from "react";
import { Flex, Header } from "@fluentui/react-northstar";
import { ReactComponent as MsTeamsError } from "../../shared/svgs/MsTeamsError.svg";
import styles from "./outsideMsTeams.module.scss";
import pl from "../../shared/messages/pl";

const OutsideMsTeams: React.FC<{}> = () => {
    return (
        <Flex className={styles.wrapper} hAlign="center" vAlign="center" column>
            <MsTeamsError className={styles.svg} />
            <Header content={pl.appOutsideMsTeams.message} align="center" />
        </Flex>
    );
};

export default OutsideMsTeams;
